import { RangeMode } from './range-display';

interface RangeInputValues {
  equal?: any;
  from?: any;
  to?: any;
  period?: string;
}

interface RangeTermOptions {
  formatValue: (value: any) => any;
  periodToRange?: (period: string) => { from: Date; to: Date } | null;
}

export function buildRangeSearchTerms(
  mode: RangeMode,
  values: RangeInputValues,
  options: RangeTermOptions
): any[] {
  if (mode === 'equal') {
    const formatted = options.formatValue(values.equal);
    return formatted === null || formatted === undefined || formatted === '' ? [] : [formatted];
  }

  if (mode === 'range') {
    const from = options.formatValue(values.from);
    const to = options.formatValue(values.to);
    if (
      (from === null || from === undefined || from === '') &&
      (to === null || to === undefined || to === '')
    ) {
      return [];
    }
    return [from ?? null, to ?? null];
  }

  if (mode === 'periods') {
    if (!values.period || !options.periodToRange) {
      return [];
    }
    const range = options.periodToRange(values.period);
    return range ? [range.from.toISOString(), range.to.toISOString()] : [];
  }

  return [];
}
